// extracted by mini-css-extract-plugin
export default {"btnPadrao":"BtnPadrao_btnPadrao__LP5D7"};